import {sequence, trigger, stagger, animate, style, group, query as q, transition, keyframes, animateChild} from '@angular/animations';
const query = (s: any,a: any, o= {optional:true})=>q(s,a,o);

export const routerTransition = trigger('routerTransition', [
  transition('* => *', [
    style({ position: 'relative' }),
    query(':enter, :leave',
      style({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
      })
    ),
    query(':enter', [
      style({ left: '100%' })
    ]),
    query(':leave', animateChild()),
    group([
      query(':leave', [
        animate('200ms ease-out', style({ left: '-100%', opacity: 0 }))
      ]),
      query(':enter', [
        animate('200ms ease-out', style({ left: '0%' }))
      ])
    ]),
    query(':enter', animateChild()),
  ]),
]);
